/**
 * A person's initials for an avatar fallback. Shared so the avatar component and the
 * Where screen's formatter can't drift apart.
 *
 * "Ada Mangum" -> "AM", "Ada" -> "A", "" -> "?".
 */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return (parts[0].slice(0, 1) + parts[parts.length - 1].slice(0, 1)).toUpperCase();
}
